function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

import React from 'react';
import PropTypes from 'prop-types';
import { KZUIComponent, Icon } from '@kuaizhan/kui';
import HeaderPulldown from './header-pulldown';
import HeaderUser from './header-user';
import HeaderMsg from './header-msg';
import Logo from '../logo/index';
import './style.less';

var HeaderBreadCrumb = function HeaderBreadCrumb(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: "header-crumb"
  }, props.list.map(function (item) {
    return /*#__PURE__*/React.createElement("div", {
      key: item.name,
      className: "header-crumb-item"
    }, /*#__PURE__*/React.createElement("a", {
      href: item.link
    }, item.text));
  }));
};

HeaderBreadCrumb.defaultProps = {
  list: []
};
HeaderBreadCrumb.propTypes = {
  list: PropTypes.arrayOf(PropTypes.object)
};

var HeaderHelp = function HeaderHelp(_ref) {
  var link = _ref.link;
  return /*#__PURE__*/React.createElement("div", {
    className: "header-cell header-help"
  }, /*#__PURE__*/React.createElement("a", {
    target: "_blank",
    href: link
  }, /*#__PURE__*/React.createElement(Icon, {
    iconClass: "kz-e-question-new"
  })));
};

HeaderHelp.defaultProps = {
  link: 'https://wiki.kuaizhan.com/pub/%E9%A6%96%E9%A1%B5'
};
HeaderHelp.propTypes = {
  link: PropTypes.string
};

var Header = /*#__PURE__*/function (_KZUIComponent) {
  _inherits(Header, _KZUIComponent);

  var _super = _createSuper(Header);

  function Header() {
    _classCallCheck(this, Header);

    return _super.apply(this, arguments);
  }

  _createClass(Header, [{
    key: "render",
    value: function render() {
      var classname = this.classname('header-new');
      var inviteCode = this.props.inviteCode;
      return /*#__PURE__*/React.createElement("div", {
        className: classname
      }, /*#__PURE__*/React.createElement("div", {
        className: "header-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "header-left"
      }, /*#__PURE__*/React.createElement(Logo, {
        href: "/",
        newLogo: true
      })), /*#__PURE__*/React.createElement("div", {
        className: "header-center"
      }, this.props.curPage ? /*#__PURE__*/React.createElement(HeaderPulldown, {
        list: this.props.pages,
        curPage: this.props.curPage
      }) : null, this.props.subPages.length > 0 ? /*#__PURE__*/React.createElement(HeaderPulldown, {
        list: this.props.subPages,
        curPage: this.props.curSubPage,
        type: "sub"
      }) : ''), /*#__PURE__*/React.createElement("div", {
        className: "header-right"
      }, /*#__PURE__*/React.createElement(HeaderBreadCrumb, {
        list: this.props.crumbData
      }), this.props.showMsg ? /*#__PURE__*/React.createElement(HeaderMsg, {
        msgList: this.props.msgList,
        onReadAllMsg: this.props.onReadAllMsg,
        onReadMsgItem: this.props.onReadMsgItem,
        unreadNum: this.props.unreadNum
      }) : null, /*#__PURE__*/React.createElement(HeaderUser, {
        inviteCode: inviteCode,
        userInfo: this.props.userInfo
      }))));
    }
  }]);

  return Header;
}(KZUIComponent);

Header.defaultProps = {
  userInfo: {
    userName: '',
    verificationStatus: 0,
    verificationType: 0
  },
  crumbData: [],
  subPages: [],
  curSubPage: '',
  unreadNum: 0,
  showMsg: true,
  inviteCode: '',
  onReadAllMsg: function onReadAllMsg() {},
  onReadMsgItem: function onReadMsgItem() {}
};
Header.propTypes = {
  pages: PropTypes.arrayOf(PropTypes.object).isRequired,
  subPages: PropTypes.arrayOf(PropTypes.any),
  crumbData: PropTypes.arrayOf(PropTypes.object).isRequired,
  userInfo: PropTypes.shape({
    userName: PropTypes.string,
    verificationStatus: PropTypes.number,
    verificationType: PropTypes.number
  }),
  curPage: PropTypes.string.isRequired,
  curSubPage: PropTypes.string,
  unreadNum: PropTypes.number,
  showMsg: PropTypes.bool,
  invitedCode: PropTypes.string,
  onReadAllMsg: PropTypes.func,
  onReadMsgItem: PropTypes.func
};
export default Header;